<template>
  <div class="toast" v-show="show">
    <p class="msg">
      {{msg}}
    </p>
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      show: true,
      msg: ""
      // time: 3000,
      // countDown: null
    };
  },
  methods: {
    open(m) {
      this.msg = m;
      // this.time = t || this.time
      this.show = true;
      // this.countDown = setTimeout(() => {
      //   this.close()
      // }, this.time)
    },
    close() {
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
.toast {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 20%;
  bottom: 0;
  left: 20%;
  margin: auto;
  height: 50px;
  max-width: 60%;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  z-index: 9999999999999;
  .msg {
    display: inline-block;
    white-space: nowrap;
    border-radius: 4px;
    padding: 0 56px;
    width: auto;
    line-height: 50px;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 14px;
  }
}
</style>
